import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=7c42697a&lang=pug&"
import script from "./fieldset.vue?vue&type=script&lang=js&"
export * from "./fieldset.vue?vue&type=script&lang=js&"
import style0 from "./fieldset.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports